import axios from "../axios";
import {
  IBlog,
  ICreateBlog,
  IDeleteBlogReq,
  IGetBlogReq,
  IGetListBlogParams,
  IGetListBlogRes,
  IUpdateBlogReq,
} from "./types";

export const getBlogCategoriesReq = async () => {
  const { data } = await axios({
    url: `/blog-category/all`,
    method: "GET",
  });
  return data;
};

export const createBlogReq = async (params: ICreateBlog) => {
  return axios({
    url: `/blog`,
    method: "POST",
    data: params,
  });
};

export const getBlogReq = async (params: IGetBlogReq): Promise<IBlog> => {
  const { data } = await axios({
    url: `/blog/${params.id}`,
    method: "GET",
  });
  return data;
};

export const updateBlogReq = async (params: IUpdateBlogReq) => {
  return axios({
    url: `/blog/${params.id}`,
    method: "PUT",
    data: params,
  });
};

export const deleteBlogReq = async (params: IDeleteBlogReq) => {
  return axios({
    url: `/blog/${params.id}`,
    method: "DELETE",
  });
};

export const getListBlogReq = async (
  params: IGetListBlogParams
): Promise<IGetListBlogRes> => {
  const { data } = await axios({
    url: `/blog/all`,
    method: "POST",
    data: params,
  });
  return data;
};
